'use strict';

function CompanyEmbedCtrl($scope, $window) {

  $scope.embedOptions = {
    imageSizes: ['16', '32', '64', '128', '256'],
    textColors: {
      black: {
        name: 'Black',
        value: '#333'
      },
      white: {
        name: 'White',
        value: '#fff'
      }
    }
  };

  $scope.embed = {
    imageSize: 32,
    textColor: $scope.embedOptions.textColors.black.value,
    fontSize: 16
  };

  $scope.selectAllText = function() {
    /* global Range */
    var range     = new Range(),
        selection = $window.getSelection();

    range.selectNodeContents(event.target);
    selection.addRange(range);
  };
}

angular.module('dokiv')
  .controller('CompanyEmbedCtrl', ['$scope', '$window', CompanyEmbedCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/account/CompanyEmbedCtrl.js
// module id = 318
// module chunks = 0